import api from './api'

export default {
  autenticar(idhotel, params){
    return api().get(`/autenticacao/${idhotel}`, { params })
  },
  statusPin(idhotel, idreservahospede){
    return api().get(`/autenticacao/${idhotel}/${idreservahospede}/status-pin`, {
      headers: { Authorization: localStorage.getItem("tokenAuthorization") },
    })
  },
  confirmarDocumento(idhotel, idreservahospede, body){
    return api().post(`/autenticacao/${idhotel}/${idreservahospede}/confirmar-documento`, body, {
      headers: { Authorization: localStorage.getItem("tokenAuthorization") },
    })
  },
}